import _ from 'underscore';
import {
  setConfig,
  show,
  showError,
  showWarning,
  showInfo,
  showConfirmation,
  dismiss,
  dismissAll,
  newAlertId,
  toastError,
  toastWarning,
  toastInfo,
  toastConfirmation,
} from '@bingads-webui-react/floating-banner';

const appendError = (errors) => {
  if (_.isArray(errors) && !_.isEmpty(errors) && errors[0].Message) {
    showError(errors[0].Message);
  }
};

const appendWarning = (warnings) => {
  if (_.isArray(warnings) && !_.isEmpty(warnings) && warnings[0].Message) {
    showWarning(warnings[0].Message);
  }
};

const appendInfo = (info) => {
  if (_.isObject(info) && info.Message) {
    showInfo(info.Message);
  }
};

const appendSuccess = (confirmation) => {
  if (_.isObject(confirmation) && confirmation.Message) {
    showConfirmation(confirmation.Message);
  }
};

const appendErrorMessage = (errorMessage) => {
  showError(errorMessage);
};

const appendWarningMessage = (warningMessage) => {
  showWarning(warningMessage);
};

const appendInfoMessage = (infoMessage) => {
  showInfo(infoMessage);
};

const appendSuccessMessage = (confirmationMessage) => {
  showConfirmation(confirmationMessage);
};

export {
  setConfig,
  appendError,
  appendWarning,
  appendInfo,
  appendSuccess,
  appendErrorMessage,
  appendWarningMessage,
  appendInfoMessage,
  appendSuccessMessage,
  show,
  showError,
  showWarning,
  showInfo,
  showConfirmation,
  dismiss,
  dismissAll,
  newAlertId,
  toastError,
  toastWarning,
  toastInfo,
  toastConfirmation,
};
